(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          max-width: 80vw;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          max-width: 50vw;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Modal as MuiModal, Fade as MuiFade } from '@material-ui/core';
import { Flex } from "../layout";
import { BORDER, SPACE, SHADOW } from "../../constants/style";
import { media } from "../../helpers/responsive";
import { Spinner } from "../loaders";
import { themeWrapper } from "../themes";
import { Heading } from "../text";
var ModalContainer = styled(Flex).withConfig({
  displayName: "Modal__ModalContainer",
  componentId: "sc-y6lo8c-0"
})(["position:relative;flex-direction:column;padding:", " ", ";background:", ";color:", ";box-shadow:", ";border-radius:", ";overflow-y:auto;box-sizing:border-box;max-height:100%;", " ", " ", ""], SPACE.xl, SPACE.lg, function (props) {
  return props.theme.styles.colors.background;
}, function (props) {
  return props.theme.styles.colors.text;
}, SHADOW.lg, BORDER.radius.sm, media.css.tablet.and('up')(_templateObject(), function (props) {
  return props.size === 'sm' ? "".concat(SPACE.xl, " ").concat(SPACE.xl) : "".concat(SPACE.xxl, " ").concat(SPACE.xxl);
}), media.css.mobile.and('down')(_templateObject2(), SPACE.xl, SPACE.xl), function (props) {
  return props.maxWidth ? "max-width: ".concat(props.maxWidth, ";") : "\n        ".concat(media.css.laptop.and('up')(_templateObject3()), "\n        ").concat(media.css.tablet.only()(_templateObject4()), "\n      ");
});
var Overlay = styled('div').withConfig({
  displayName: "Modal__Overlay",
  componentId: "sc-y6lo8c-1"
})(["position:absolute;top:0;left:0;bottom:0;right:0;flex-direction:column;align-items:center;justify-content:center;flex:1 0 0;display:flex;background-color:rgba(0,0,0,0.15);"]);
var SpinnerWrapper = styled('div').withConfig({
  displayName: "Modal__SpinnerWrapper",
  componentId: "sc-y6lo8c-2"
})(["background:", ";padding:36px;border-radius:", ";box-shadow:", ";"], function (props) {
  return props.theme.styles.colors.background;
}, BORDER.radius.lg, SHADOW.lg);
var ModalHeading = styled(Heading).withConfig({
  displayName: "Modal__ModalHeading",
  componentId: "sc-y6lo8c-3"
})(["text-transform:uppercase;letter-spacing:0.04em;"]);

var Modal = function Modal(props) {
  var children = props.children,
      heading = props.heading,
      open = props.open,
      isLoading = props.isLoading,
      size = props.size,
      rest = _objectWithoutProperties(props, ["children", "heading", "open", "isLoading", "size"]);

  var sizes = {
    sm: {
      maxWidth: '320px',
      titleFontSize: '20px',
      titleMarginBottom: '8px'
    },
    md: {
      maxWidth: '480px',
      titleFontSize: '24px',
      titleMarginBottom: '16px'
    },
    lg: {
      maxWidth: '1000px',
      titleFontSize: '24px',
      titleMarginBottom: '16px'
    }
  };
  var _sizes$size = sizes[size],
      titleFontSize = _sizes$size.titleFontSize,
      titleMarginBottom = _sizes$size.titleMarginBottom,
      maxWidth = _sizes$size.maxWidth;
  return React.createElement(MuiModal, _extends({
    open: open,
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, rest), React.createElement(MuiFade, {
    "in": open
  }, React.createElement(ModalContainer, {
    maxWidth: maxWidth,
    size: size
  }, heading ? React.createElement(ModalHeading, {
    center: true,
    level: 3,
    fontSize: titleFontSize,
    marginBottom: titleMarginBottom
  }, heading) : null, children, isLoading ? React.createElement(Overlay, null, React.createElement(SpinnerWrapper, null, React.createElement(Spinner, null))) : null)));
};

Modal.defaultProps = {
  size: 'md',
  open: true,
  isLoading: false
};
Modal.propTypes = {
  isLoading: PropTypes.bool,
  open: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  onClose: PropTypes.func
};

var _default = themeWrapper(Modal);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ModalContainer, "ModalContainer", "/home/vsts/work/1/s/src/components/overlays/Modal.js");
  reactHotLoader.register(Overlay, "Overlay", "/home/vsts/work/1/s/src/components/overlays/Modal.js");
  reactHotLoader.register(SpinnerWrapper, "SpinnerWrapper", "/home/vsts/work/1/s/src/components/overlays/Modal.js");
  reactHotLoader.register(ModalHeading, "ModalHeading", "/home/vsts/work/1/s/src/components/overlays/Modal.js");
  reactHotLoader.register(Modal, "Modal", "/home/vsts/work/1/s/src/components/overlays/Modal.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/overlays/Modal.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();